import React from "react";
import Header from "../header/Header";
import IconoPerfil from "../../assests/imagenes/img_perfil.svg";
import style from "./Carta.module.css";
import iconReservas from "../../assests/imagenes/calendar-clock 1.png";

const CartaHeader = ({
  onPerfilClick,
  onVinosClick,
  mostrarVinos,
  headerPartRef,
  onReservasClick,
  isMobile,
}) => {
  return (
    <div className={style.header_part} ref={headerPartRef}>
      <Header />
      <div className={style.menu_container}>
        <div className={style.perfil_reservas_container}>
          <div className={style.mi_perfil} onClick={onPerfilClick}>
            <div className={style.perfil_icon_container}>
              <img
                src={IconoPerfil}
                alt="Perfil"
                className={style.perfil_icon}
              />
              <span className={style.perfil_text}>Mi Perfil</span>
            </div>
          </div>

          <div className={style.mi_perfil} onClick={onReservasClick}>
            <div className={style.perfil_icon_container}>
              {" "}
              <img src={iconReservas} className={style.iconReserva} />{" "}
              <span className={style.perfil_text}>Reservar</span>
            </div>
          </div>

        </div>

        <div className={style.div_boton_vinos}>
          <button
            type="button"
            className={style.formato_botones}
            onClick={onVinosClick}
          >
            {mostrarVinos ? "Categorías" : "Carta de vinos"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartaHeader;
